import { useState } from "react";
// mui components
import { Box, Switch } from "@mui/material";
//axios
import EnhancedAxios from "../../api/EnhancedAxios";
// redux hooks
import { useSelector } from "react-redux";
// alerts
import { successAlert, errorAlert } from "../../utils/alerts";

const UserTesterToggler = ({ id, is_tester }) => {
    const [value, setValue] = useState(is_tester);
    const userToken = useSelector((state) => state.userToken);
    const handleChange = (e) => {
        setValue(e.target.checked);
        const formData = new FormData();
        formData.append("is_tester", e.target.checked);

        EnhancedAxios("multipart/form-data", userToken)
            .put(`/admin/users/${id}`, formData)
            .then((response) => {
                const alertMsg = response?.data?.is_tester
                    ? "تم اضافة الاذن الوصول المبكر الى المستخدم"
                    : "تم ازالة الاذن الوصول المبكر من المستخدم";
                successAlert(alertMsg);
                setValue(response?.data?.is_tester ? true : false);
            })
            .catch((error) => {
                errorAlert(error);
            });
    };
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
            }}
        >
            <Switch
                checked={value}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
                size="small"
            />
        </Box>
    );
};

export default UserTesterToggler;
